import { createStore } from 'vuex'
import { auth, db} from '@/firebase/gfbconf'
import axios from 'axios';

export default createStore({
  state: {
    apiLink: "https://europe-central2-lauron-a8b59.cloudfunctions.net/api",
    apiLinkLocal: "http://127.0.0.1:5001/lauron-a8b59/europe-central2/api",
    apiComplaiaLink: "https://urzad.cmplapis.com/api/private",
    apiComplaiaLinkLocal: "http://localhost:3000/api/private",
    notification: {
      show: false,
      head: "",
      subheader: "",
      success: true,
    },
    user: null,
    userData: null,
    authIsReady: false,
    transactions: {
      uninvoiced: [],
      user: null,
    },
    globalLoader: {
      show: false,
      head: "Loading..",
      subheader: "Don't close this tab."
    }
  },
  mutations: {
    setNotification(state, notification)
    {
      state.notification = notification;
      setTimeout(()=>
      {
        state.notification = {
          show: false,
          head: "",
          subheader: "",
          success: true,
        }
      },3000)
    },
    setUrl(state, url)
    {
      state.url = url
    },
    setUninvoicedTransactions(state, data)
    {
      state.transactions = {
        uninvoiced: data.transactions,
        user: data.user
      }
    },
    // Set user to Vuex store
    setUser(state, userData)
    {
      state.user = userData;
    },
    updateInternetConnectionStatus(state, status)
    {
      state.internetConnection = status;
    },
    setUserCredentials(state, userData)
    {
      state.userData = userData;
    },
    setAuthIsReady(state,payload)
    {
      state.authIsReady = payload;
    },
    // reset global loader
    resetGlobalLoader(state)
    {
      state.globalLoader = {
        show: false,
        head: "Ładowanie..",
        subheader: "Nie zamykaj tego okna."
      }
    },
    setGlobalLoader(state,context)
    {
      state.globalLoader = context;
    },
  },
  actions: {
    //login new user
    async login(context,payload)
    {
      const signIn = await auth.signInWithEmailAndPassword(payload.email, payload.password);
      if (signIn) {
        const userCredentials = await db.collection("WorkersData").doc(signIn.user.uid).get();
        if(userCredentials.exists){
          context.commit('setGlobalLoader',{
            show: true,
            head: "Sprawdzanie twoich danych..",
            subheader: `Nie zamykaj okna.`,
            success: false
        });
        context.commit('setUserCredentials', userCredentials.data());
        context.commit('setUser', signIn.user);
        }else{
          throw new Error("Could not complete login action.")
        }
          
      } else {
        throw new Error("Could not complete login action.")
      }
    },
    // logout user;
    async logout(context)
    {
      context.state.authIsReady = false;
      await auth.signOut();
      context.commit('setUser', null);
      context.commit("resetGlobalLoader");
    }
  },
  modules: {
  }
})
